import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }
const _hoisted_2 = { class: "flex flex-col gap-2" }

import { computed, ref, watch } from 'vue';
    import { InputRow, Select } from '@/components/ui/form';
    import { Label } from '@/components/ui/label';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import FileUploadZone from '@/components/FileUploadZone.vue';
    import type { ContraAccount, FileItem, SharedData } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';

    const MAX_UPLOADS = 5;
    const MAX_SIZE = 9 * 1024 * 1024;

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherStatementUploadForm',
  props: {
    form: {},
    contraAccounts: {}
  },
  emits: ["files-processing", "files-registered"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const uploadZoneRef = ref<InstanceType<typeof FileUploadZone>>();
    const uploadedFiles = ref<FileItem[]>([]);
    const queryClient = useQueryClient();

    const { t } = useI18n();

    const options = computed(() => {
        return props.contraAccounts.map((account: ContraAccount) => ({
            value: account.ContraAccountHandle_Number,
            label: `${account.ContraAccountHandle_Number} - ${account.name}`,
        }));
    });

    watch(
        () => props.contraAccounts,
        (newOptions, oldOptions) => {
            if (!oldOptions || (newOptions && oldOptions.length !== newOptions.length)) {
                props.form.contra_account_id = newOptions[0].ContraAccountHandle_Number;
            }
        },
        { immediate: true },
    );

    watch(
        () => uploadedFiles.value,
        (newFiles) => {
            if (newFiles.length > 0) {
                props.form.voucher_statement_id = newFiles[0].voucher_statement_id;
            }
        },
    );

    watch(
        () => props.form.contra_account_id,
        (newContraAccountId) => {
            if (newContraAccountId) {
                props.form.voucher_statement_id = null;
                uploadedFiles.value = [];
            }
        },
    );

    const handleFilesProcessing = (processing: boolean) => {
        emit('files-processing', processing);
    };

    const markFilesAsRegistered = () => {
        uploadZoneRef.value?.markFilesAsRegistered();
        emit('files-registered');
    };

    const hasUnregisteredFiles = computed(() => {
        return uploadedFiles.value.some((file) => file.uploaded && !file.registered);
    });

    __expose({
        markFilesAsRegistered,
        hasUnregisteredFiles,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "contra_account_id",
      label: "vouchers.account_handle"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.contra_account_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contra_account_id) = $event)),
          options: options.value,
          disabled: hasUnregisteredFiles.value
        }, null, 8, ["modelValue", "options", "disabled"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Label), { for: "upload_statement" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('vouchers.upload_statement', {
                        max_uploads: MAX_UPLOADS,
                    })), 1)
        ]),
        _: 1
      }),
      _createVNode(FileUploadZone, {
        modelValue: uploadedFiles.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uploadedFiles).value = $event)),
        ref_key: "uploadZoneRef",
        ref: uploadZoneRef,
        "accepts-files": ['.pdf'],
        "instant-upload": "",
        route: _ctx.route('v2.voucher.admin.statement.upload'),
        "additional-fields": {
                    company_id: companyId.value,
                    contra_account: _ctx.form.contra_account_id,
                    ...(props.form.voucher_statement_id && {
                        voucher_statement_id: props.form.voucher_statement_id,
                    }),
                },
        "batch-upload": "",
        multiple: "",
        "max-uploads": MAX_UPLOADS,
        "max-size": MAX_SIZE,
        onFilesProcessing: handleFilesProcessing,
        onSuccess: _cache[2] || (_cache[2] = () => _unref(queryClient).invalidateQueries({ queryKey: [_unref(QueryKey).VOUCHERS, companyId.value] }))
      }, null, 8, ["modelValue", "route", "additional-fields"])
    ])
  ]))
}
}

})